import { render, staticRenderFns } from "./SlaSolicitudes.vue?vue&type=template&id=38992d14"
import script from "./SlaSolicitudes.vue?vue&type=script&lang=js"
export * from "./SlaSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports